export default __webpack_public_path__ + "static/media/leave_home.a791b50c.svg";